"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _FormContext = _interopRequireDefault(require("./FormContext"));
const FormGroup = _ref => {
  let {
    controlId,
    className,
    children
  } = _ref;
  const [isFocus, setIsFocus] = _react.default.useState(false);
  const [isRequired, setIsRequired] = _react.default.useState(false);
  const [isInvalid, setIsInvalid] = _react.default.useState(false);
  const [state, setState] = _react.default.useState(undefined);
  const context = _react.default.useMemo(() => ({
    controlId,
    isFocus,
    isInvalid,
    state,
    required: isRequired,
    onBlur: () => setIsFocus(false),
    onFocus: () => setIsFocus(true),
    onRequiredChange: required => setIsRequired(required),
    setIsInvalid: isInvalid => setIsInvalid(isInvalid),
    setState: newState => setState(newState)
  }), [controlId, isFocus, setIsFocus, isRequired, isInvalid]);
  return /*#__PURE__*/_react.default.createElement(_FormContext.default.Provider, {
    value: context
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)('formGroup', state !== undefined ? `formGroup-${state}` : null, className)
  }, children));
};
process.env.NODE_ENV !== "production" ? FormGroup.propTypes = {
  controlId: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node
} : void 0;
FormGroup.defaultProps = {
  controlId: undefined,
  className: undefined,
  children: undefined
};
var _default = exports.default = FormGroup;